<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>回收站</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="title" label="公司名称" align="center" />
      <el-table-column prop="created_at" label="创建时间" align="center" />
      <!-- <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success" size="mini"
            >运行</el-tag
          >
          <el-tag v-if="scope.row.status == 0" type="danger" size="mini"
            >停运</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            彻底删除
          </el-button>
          <el-button
            @click.native.prevent="findsingleDel(scope.row, scope.row.id)"
            type="primary"
            size="small"
            icon="el-icon-refresh-left"
          >
            恢复
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import {
  getDeleteList,
  alldeleteCompany,
  findeditCompany,
} from "../../api/userMG";
export default {
  mixins: [tableCommon],
  data() {
    return {
      // 请求地址api
      api: {
        list: getDeleteList,
        del: alldeleteCompany,
      },
      tableData: [],
      searchForm: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    // 找回公司
    findsingleDel(req) {
      this.$confirm("确定恢复这条数据？", "恢复数据", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        findeditCompany(req).then((res) => {
          console.log(res)
          if (res.code !== 200)
            return this.$message.error(res.msg ? res.msg : "恢复失败!");
          this.$message.success("恢复成功");
          this.initList();
        });
      });
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/companys/deleteList.vue